import React from 'react';
import PropTypes from 'prop-types';

export default function AIcon({ type, className }) {
	let style;

	switch (type) {
		case 'arrowUp':
			style = 'a-arrow a-arrow--up';
			break;
		case 'arrowRight':
			style = 'a-arrow a-arrow--right';
			break;
		case 'arrowDown':
			style = 'a-arrow a-arrow--bottom';
			break;
		case 'arrowLeft':
			style = 'a-arrow a-arrow--left';
			break;
		case 'pin':
			style = 'a-map-pin';
			break;
		case 'pdf':
			style = 'a-document--pdf';
			break;
		case 'close':
			style = 'a-close';
			break;
		default:
			style = `a-${type}`;
			break;
	}

	return (
		<div className={`${style} ${className}`} />
	);
}

AIcon.propTypes = {
	type: PropTypes.string.isRequired,
	className: PropTypes.string,
};

AIcon.defaultProps = {
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.icon.js